import { getPerfilLogado, PerfilLogado } from "./api";

type PerfilResource = {
  status: "pending" | "success";
  value: PerfilLogado | null;
  promise: Promise<void>;
};

let resource: PerfilResource | null = null;

/**
 * Lê o perfil logado de forma "suspensível": dá throw na promise pro <Suspense>
 * segurar o skeleton. A API é a única fonte da verdade do login e
 * getPerfilLogado() nunca rejeita, então dispensa Error Boundary.
 */
export function readPerfilLogado(): PerfilLogado | null {
  if (resource === null) {
    const pending: PerfilResource = {
      status: "pending",
      value: null,
      promise: Promise.resolve(),
    };
    pending.promise = getPerfilLogado().then((data) => {
      pending.status = "success";
      pending.value = data;
    });
    resource = pending;
  }

  if (resource.status === "pending") {
    throw resource.promise;
  }

  return resource.value;
}
